import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MESSAGE_QUERY_PARAM } from '../../constants/auth.constants';

@Component({
  selector: 'app-not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.css'],
  standalone: false
})
export class NotAuthorizedComponent implements OnInit {
  message: string = 'You are not authorized to access this application.';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    const customMessage = this.route.snapshot.queryParams[MESSAGE_QUERY_PARAM];
    if (customMessage) {
      this.message = decodeURIComponent(customMessage);
    }
  }
}
